import type { TableDataHook } from "@/features/integrations/shared/renderer/hooks/types";

export type TableDataHookGetter = (
  clientId?: string
) => TableDataHook | undefined;

const tableDataHooksRegistry = new Map<string, TableDataHookGetter>();

export function registerDirectApplyTableDataHook(
  integrationName: string,
  getter: TableDataHookGetter
): void {
  tableDataHooksRegistry.set(integrationName.toLowerCase(), getter);
}

export function getDirectApplyTableDataHook(
  integrationName: string | undefined,
  clientId?: string
): TableDataHook | undefined {
  if (!integrationName) return undefined;
  const getter = tableDataHooksRegistry.get(integrationName.toLowerCase());
  return getter?.(clientId);
}
